// extracted by mini-css-extract-plugin
module.exports = {"c-footer-projects":"_84ff5fbbc9--c-footer-projects--NplLh","c-footer-projects-item":"_84ff5fbbc9--c-footer-projects-item--MpYue"};